// HTTP methods
export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const;

// HTTP status codes (includes FE-only codes)
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  VALIDATION_ERROR: 400,
  AUTHORIZATION_ERROR: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  // FE-only codes (not standard HTTP)
  SCHEMA_VALIDATION_ERROR: 4220
} as const;

export type HTTPStatusCode = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS];

// Error types
export const ERROR_TYPE = {
  NETWORK: 'NetworkError',
  SCHEMA_VALIDATION: 'SchemaValidationError',
  API_RESPONSE: 'ApiResponseError',
  UNKNOWN: 'UnknownError'
} as const;

// HTTP headers
export const HTTP_CONTENT_TYPE_JSON = 'application/json';
export const HTTP_AUTHORIZATION_HEADER = 'Authorization';
export const HTTP_CONTENT_TYPE_HEADER = 'Content-Type';
